import BaseSchemaExtender from './BaseSchemaExtender';

// TextAreaSchemaExtender reusa o BaseSchemaExtender
export const TextAreaSchemaExtender = BaseSchemaExtender;

export default TextAreaSchemaExtender;
